import type { Dayjs } from 'dayjs';

const DATE_TIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss';

export const toServerDateTime = (value: Dayjs): string => value.format(DATE_TIME_FORMAT);

export const getDayRange = (
  date: Dayjs
): {
  dateFrom: string;
  dateTo: string;
} => ({
  dateFrom: toServerDateTime(date.startOf('day')),
  dateTo: toServerDateTime(date.endOf('day')),
});
